import {api} from 'api/setup';
import {API_HOST, isDev, isStage} from 'config';
import {ISeoMetadata, LanguageEnum, ProviderTypeEnum} from 'types';

const baseURL = `${API_HOST}/api`;

export const getSeoBySlug = (slug: string, locale: string = LanguageEnum.RO): Promise<ISeoMetadata> => {
  if (isDev || isStage) return Promise.resolve({} as ISeoMetadata);
  try {
    return api.get(`/seo-metadata/${slug}`, {
      baseURL,
      headers: {
        ['Accept-Language']: locale,
      },
    });
  } catch (error) {
    return Promise.reject();
  }
};
export const getAllProviders = (): Promise<
  {
    provider_type: ProviderTypeEnum;
    slug: string;
  }[]
> => {
  try {
    return api.get(`/sitemap/provider`);
  } catch (error) {
    return Promise.reject();
  }
};
